import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './OnboardingPanelBio.scss';

import UploadImage from '../../../Components/General/UploadImage';
import { getUserId, getName, getBio, getImage } from '../../../Helpers/user_helpers';
import { matchScrollHeight } from '../../../Helpers/helpers';

let debounceSave;
const OnboardingPanelBio = props => {
  const { updateCurrentUser, user } = props;
  const [name, setName] = useState(getName(user) || '');
  const [description, setDescription] = useState(getBio(user) || '');
  const [image, setImage] = useState(getImage(user));

  const updateImage = newImage => {
    setImage(newImage);
    saveData({ image: newImage, name, description });
  };

  const updateName = newName => {
    setName(newName);
    saveData({ image, name: newName, description });
  };

  const updateDescription = newDescription => {
    setDescription(newDescription);
    saveData({ image, name, description: newDescription });
  };

  const saveData = data => {
    clearTimeout(debounceSave);
    debounceSave = setTimeout(() => {
      updateCurrentUser(data, getUserId(user));
    }, 800);
  };

  return (
    <div className='onboarding-panel-bio-container'>
      <div className='onboarding-header'>Tell us about yourself</div>
      <div className='onboarding-subheader'>This information will appear on your public shop header.</div>
      <div className='profile-data-panel'>
        <div className='profile-image'>
          <UploadImage imagesOnly currentImage={image} hiddenHeader completeUpload={updateImage} />
        </div>
        <textarea type='text' rows='1' className='name' placeholder='Your Name' onChange={({ target }) => updateName(target.value)} value={name} />
        <textarea
          type='text'
          rows='4'
          ref={ref => matchScrollHeight(ref)}
          className='description'
          placeholder='Tell your shop visitors a little bit about yourself (optional)'
          onChange={({ target }) => updateDescription(target.value)}
          value={description}
        />
      </div>
    </div>
  );
};

OnboardingPanelBio.propTypes = {
  user: PropTypes.object.isRequired,
  updateCurrentUser: PropTypes.func.isRequired
};

export default OnboardingPanelBio;
